import { AutogenLayoutDriverPayRateDetails } from "./autogen/AutogenLayoutDriverPayRateDetails";
import { DisplayType, ModelRow } from "@mcleod/core";
import {
    DataSourceMode, DropdownSelectionEvent, Table, TableRow, TableRowBeforeSaveEvent, TableRowCreationEvent,
    TableRowDisplayEvent, TableRowMode, Textbox, ValidationResult
} from "@mcleod/components";

export class DriverPayRateDetails extends AutogenLayoutDriverPayRateDetails {
    private _rateRow: ModelRow;

    onLoad() {
        this.tableDriverPayRateDetails.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const textboxSequence = tableRow.findComponentById("textboxSequence") as Textbox;
            if (textboxSequence && tableRow.mode === TableRowMode.QUICK_ADD) {
                textboxSequence.visible = false;
            }
            this.setSingleTeamFields(tableRow);
            const textboxBeginningDistance = tableRow.findComponentById("textboxBeginningDistance") as Textbox;
            if (textboxBeginningDistance) {
                textboxBeginningDistance.addlValidationCallback = () => {
                    const result: ValidationResult = {
                        isValid: true,
                        component: textboxBeginningDistance
                    };
                    const beginningDistance = tableRow.data.get("beginning_distance");
                    const endingDistance = tableRow.data.get("ending_distance");
                    if (beginningDistance != null && endingDistance != null && beginningDistance > endingDistance) {
                        result.isValid = false;
                        result.validationMessage = "Beginning distance can not be greater than ending distance";
                    }
                    return result;
                };
            }
            const textboxEndingDistance = tableRow.findComponentById("textboxEndingDistance") as Textbox;
            if (textboxEndingDistance) {
                textboxEndingDistance.addlValidationCallback = () => {
                    const result: ValidationResult = {
                        isValid: true,
                        component: textboxEndingDistance
                    };
                    const beginningDistance = tableRow.data.get("beginning_distance");
                    const endingDistance = tableRow.data.get("ending_distance");
                    if (beginningDistance != null && endingDistance == null) {
                        result.isValid = false;
                        result.validationMessage = "Ending distance is required when beginning distance is entered";
                    }
                    return result;
                };
            }
        });
    }

    initialize(rateRow: ModelRow, data: ModelRow[]) {
        this.rateRow = rateRow;
        data.sort((a: ModelRow, b: ModelRow) => a.get("sequence") - b.get("sequence"));
        this.tableDriverPayRateDetails.dataSource.setRowsAndMode(DataSourceMode.UPDATE, data);
    }

    set rateRow(data: ModelRow) {
        this._rateRow = data;
    }

    get rateRow(): ModelRow {
        return this._rateRow;
    }

    private onRowCreate(table: Table, event: TableRowCreationEvent) {
        if (event.getTableRow().data._appending && this.rateRow) {
            event.getTableRow().data.set("header_id", this.rateRow.get("primary_key"));
            event.getTableRow().data.set("pay_rate_group", this.rateRow.get("id"));
        }
    }

    tableDriverPayRateDetailsBeforeRowSave(event: TableRowBeforeSaveEvent) {
        const row = event.getTableRow();
        if (row.mode === TableRowMode.QUICK_ADD) {
            row.data.set("sequence", this.sourceDrsPayrate.data.length + 1);
            this.tableDriverPayRateDetails.quickAddRow.displayComponentValues();
        }
    }

    tableDriverPayRateDetailsOnRowCreate(event: TableRowCreationEvent) {
        this.onRowCreate(this.tableDriverPayRateDetails, event);
    }

    setSingleTeamFields(tableRow: TableRow) {
        const textboxSingleLoadedRate = tableRow.findComponentById("textboxSingleLoadedRate") as Textbox;
        const textboxSingleEmptyRate = tableRow.findComponentById("textboxSingleEmptyRate") as Textbox;
        const textboxTeamLoadedRate = tableRow.findComponentById("textboxTeamLoadedRate") as Textbox;
        const textboxTeamEmptyRate = tableRow.findComponentById("textboxTeamEmptyRate") as Textbox;
        const rateMethod = tableRow.data.get("rate_method");
        this.setSingleTeamFieldDisplayType(textboxSingleLoadedRate, rateMethod);
        this.setSingleTeamFieldDisplayType(textboxSingleEmptyRate, rateMethod);
        this.setSingleTeamFieldDisplayType(textboxTeamLoadedRate, rateMethod);
        this.setSingleTeamFieldDisplayType(textboxTeamEmptyRate, rateMethod);
        tableRow.displayComponentValues();
    }

    setSingleTeamFieldDisplayType(textbox: Textbox, rateMethod: string) {
        if (textbox) {
            textbox.displayType = rateMethod === "D" ? DisplayType.DECIMAL : DisplayType.PERCENTAGE;
            textbox.maxValue = rateMethod === "P" ? 100 : null;
        }
    }

    textboxRateMethodAfterDropdownSelection(event: DropdownSelectionEvent) {
        if (event.hasSelection()) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            this.setSingleTeamFields(tableRow);
        }
    }
}
